module.exports = __webpack_public_path__ + "static/img/pico22.01ea314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico22.png
// module id = jb7E
// module chunks = 0